import React, { Fragment, useState, useEffect } from "react";
import "./pactometro.scss";
import { ResultProvider } from "../../dataProvider/results";
import { getResultOrigin } from "../../dataProvider/origin";
import { TYPES, SUBTYPES } from "../../envs/core";
import Header from "../../components/header";
import PactometroCheck from "../../components/pactometroCheck";
//import { PactometroProps } from '../../constants/pactometroProps';

const getTitle = () => {
  let host = window.location.hostname.replace("localhost", "antena3");
  let title;
  if (host.indexOf("lasexta") >= 0) {
    title = "10-N PACTÓMETRO";
  } else if (host.indexOf("antena3") >= 0) {
    title = (
      <Fragment>
        CALCULADORA DE PACTOS
      </Fragment>
    );
  } else if (host.indexOf("ondacero") >= 0) {
    title = "PACTOS";
  }
  return title;
};

const Pactometro = ({ match }) => {
  const { year, type, electionNumber, placesIds } = match.params;

  const [resultOrigin, setResultOrigin] = useState({});

  useEffect(() => {
    getResultOrigin(year, type, electionNumber, placesIds)
      .then(historicResult => {
        setResultOrigin(historicResult);
      })
      .catch(err => {});
  }, [year, type, electionNumber]);

  return (
    <div className="pagePactometro">
      <Header>
        <h2>{getTitle()}</h2>
      </Header>
      {resultOrigin && resultOrigin.primary && (
        <ResultProvider
          electionPlace={placesIds}
          active={resultOrigin.primary.active}
          year={year}
          type={type}
          subtype={type === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE}
          electionNumber={electionNumber}
          placeId={placesIds}
        >
          {dataResult =>
            dataResult.partiesResult ? (
              <PactometroCheck
                seatData={dataResult.partiesResult}
                totalSeat={dataResult.totalSeats}
              />
            ) : (
              <p>Cargando</p>
            )
          }
        </ResultProvider>
      )}
    </div>
  );
};

export default Pactometro;
